module.exports = __webpack_public_path__ + "static/media/4.33113f07.png";